import DescriptionIcon from "@mui/icons-material/Description";
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { CountryEnum } from "@/types/enum/enumUser";


const routeDocumentTemplateRoutes = [
  {
    route: 'DocumentTemplates',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Template Document',
    icon: DescriptionIcon,
    href: '/backoffice/group/document-templates',
    menuHeader: true,
    position: 320,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  {
    route: 'DocumentTemplateNew',
    text: 'Template Document',
    href: '/backoffice/group/document-templates/new',
    menuHeader: false,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  {
    route: 'DocumentTemplateEdit',
    text: 'Template Document',
    href: '/backoffice/group/document-templates/[id]',
    menuHeader: false,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
]


export default routeDocumentTemplateRoutes
